import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { FeatureTogglesFacade } from '@cigna/shared/angular/features-feature';
import { Subject, takeUntil } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class AuthGuardOkta {
  constructor(
    private featureTogglesFacade: FeatureTogglesFacade,
    private router: Router,
  ) {}
  isAuthGuardToggleOn: boolean;
  isAuthGuardEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'isAuthGuardEnabled',
  ]);
  private _ngUnsubscribe$: Subject<void> = new Subject<void>();
  canActivate(
    _next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    if (this.isPostLogoutLanding(state.url)) {
      return true;
    }

    this.isAuthGuardEnabled$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((isAuthGuardEnabled) => {
        this.isAuthGuardToggleOn = isAuthGuardEnabled;
      });

    // Feature flags load asynchronously; allow public routes until the first
    // value arrives. Redirecting to /secure/home here caused a stuck
    // "Loading..." state after unified-portal logout (fresh page load).
    if (this.isAuthGuardToggleOn === undefined) {
      return true;
    }

    if (this.isAuthGuardToggleOn) {
      return true;
    }

    this.router.navigate(['/secure/home']);
    return false;
  }

  private isPostLogoutLanding(url: string): boolean {
    return (
      url.includes('userstatus=logoff') || url.includes('userstatus=timeout')
    );
  }
}
